// extracted by mini-css-extract-plugin
export var currentStep = "_mg-2";
export var nodeCard = "_mg-0";
export var pathHighlighted = "_mg-1";